import LabelledSelect from './LabelledSelect';

export default LabelledSelect;
